<template>
  <header class="header">
  </header>

</template>

<script>
export default {
  name: 'HeaderPage'
}
</script>
